"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _useSelectState = require("@commerce-ui/core2/useSelectState");
var _useMultiSelectState = require("@commerce-ui/core2/useMultiSelectState");
var _RangePicker = require("@commerce-ui/core2/RangePicker");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var normalizeData = function normalizeData(item) {
  var ret = _objectSpread({}, item);
  if (ret.type === "select") {
    ret.value = (0, _useSelectState.normalizeSelectValue)(ret.options, ret.value, true);
  } else {
    ret.value = null; // TODO: do this
  }
  return ret;
};
var areEqual = function areEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
};
function getValuesObject(data) {
  var obj = {};
  data.forEach(function (item) {
    obj[item.id] = item.value;
  });
  return obj;
}
var normalizeFilterValue = function normalizeFilterValue(filter) {
  if (filter.type === "select") {
    return (0, _useSelectState.normalizeSelectValue)(filter.options, filter.value, true);
  } else if (filter.type === "multiselect") {
    return (0, _useMultiSelectState.normalizeMultiSelectValue)(filter.options, filter.value);
  } else if (filter.type === "range") {
    return (0, _RangePicker.normalizeRangePickerValue)(_objectSpread(_objectSpread({}, filter), {}, {
      fractionDigits: filter.id === "capacity" ? 3 : 2
    }), false);
  } else {
    return null;
  }
};

/**
 * TODO: don't run onChange when nothing changed (even if commit was run)
 */

// for now: enableReinitalize not available, we assume true.
function useNormalizeAndMapFilters(_ref) {
  var _data, _data2;
  var data = _ref.data,
    onChange = _ref.onChange,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var _useState = (0, _react.useState)(0),
    counter = _useState[0],
    setCounter = _useState[1];
  var localValues = (0, _react.useRef)({});
  var committedValues = (0, _react.useRef)({});
  var previousValues = (0, _react.useRef)({});
  var filterClear = (0, _react.useRef)({
    id: null,
    clear: false,
    clearAll: false
  });
  data = (_data = data) === null || _data === void 0 ? void 0 : _data.map(function (filter) {
    if ((filter === null || filter === void 0 ? void 0 : filter.id) === "capacity" && !filter.isConverted) {
      var _filter$value, _filter$value2;
      return _objectSpread(_objectSpread({}, filter), {}, {
        isConverted: true,
        max: filter.max / 1000,
        min: filter.min / 1000,
        value: filter.value && {
          from: ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.from) / 1000,
          to: ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.to) / 1000
        }
      });
    }
    return filter;
  });
  var values = {}; // normalized values based on current data
  (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.forEach(function (filter) {
    values[filter.id] = normalizeFilterValue(filter);
  });

  // UPDATE local values (makes sense if data changes and we have different filters structure)
  // Thanks to refs we can do this "right away", not on useEffect and cause re-render.

  for (var filterId in localValues.current) {
    // If new value for this filter from props is different from previous value from props (like value from server changed)
    if (!areEqual(values[filterId], previousValues.current[filterId])) {
      delete localValues.current[filterId];
      delete committedValues.current[filterId];
    }

    // If this filterId is not in the list anymore
    if (!values.hasOwnProperty(filterId)) {
      delete localValues.current[filterId];
      delete committedValues.current[filterId];
    }
  }
  previousValues.current = _objectSpread({}, values);
  var getDataWithCurrentValues = function getDataWithCurrentValues() {
    var _data3;
    return (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.map(function (item) {
      var value = localValues.current[item.id] === undefined ? values[item.id] : localValues.current[item.id]; // null means that it was set by clear
      var committedValue = committedValues.current[item.id] === undefined ? values[item.id] : committedValues.current[item.id];
      if (item.id === filterClear.current.id && filterClear.current.clear) {
        value = [];
        committedValue = [];
      }
      var nullValue = normalizeFilterValue(_objectSpread(_objectSpread({}, item), {}, {
        value: null
      }));
      var isDirty = !areEqual(value, committedValue);
      var isEmpty = areEqual(value, nullValue);
      var isCommittedEmpty = areEqual(committedValue, nullValue);
      value = isEmpty ? null : value;
      committedValue = isCommittedEmpty ? null : committedValue;
      return _objectSpread(_objectSpread({}, item), {}, {
        value: value,
        committedValue: committedValue,
        isDirty: isDirty,
        isEmpty: isEmpty,
        isCommittedEmpty: isCommittedEmpty
      });
    });
  };
  var setValue = function setValue(id, newValue) {
    var isSoft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var runOnChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    // normalize
    var emptyValue = newValue === null;
    var filter = data.find(function (x) {
      return x.id === id;
    });
    newValue = normalizeFilterValue(_objectSpread(_objectSpread({}, filter), {}, {
      value: newValue
    }));
    if (areEqual(newValue, localValues.current[id])) {
      // don't run onChange when requesting same change
      return;
    }
    if (emptyValue && !isMobile) {
      localValues.current[id] = null;
      delete localValues.current[id];
      delete committedValues.current[id];
      if (filter.value && onChange && runOnChange) {
        filterClear.current = _objectSpread(_objectSpread({}, filterClear.current), {}, {
          id: id,
          clear: emptyValue
        });
      } else {
        filterChangedWithNoCommittedValues = true;
      }
    } else if (!isSoft) {
      localValues.current[id] = newValue;
      committedValues.current[id] = newValue;
      filter.isDirty = false;
      var newData = getDataWithCurrentValues();
      if (onChange && runOnChange) {
        onChange(newData);
      }
    } else {
      localValues.current[id] = newValue;
    }
    setCounter(counter + 1);
  };
  var filterChangedWithNoCommittedValues = false;
  var isAnyDirty = false;
  var areAllEmpty = true;
  var anyFilterChanged = false;
  var currentData = getDataWithCurrentValues();
  currentData === null || currentData === void 0 ? void 0 : currentData.forEach(function (item) {
    if (item.isDirty) {
      isAnyDirty = true;
    }
    if (!item.isEmpty) {
      areAllEmpty = false;
    }
  });
  var commit = function commit() {
    var isProMultiselect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    committedValues.current = _objectSpread({}, localValues.current);
    var newData = getDataWithCurrentValues();
    var filtersChanged = isMobile && filterClear.current.clearAll ? filterClear.current.clear : isAnyDirty || filterClear.current.clear || isProMultiselect;
    anyFilterChanged = filtersChanged;
    if (onChange && !filterChangedWithNoCommittedValues && filtersChanged) {
      onChange(newData);
      filterClear.current = _objectSpread(_objectSpread({}, filterClear.current), {}, {
        id: null,
        clear: false,
        clearAll: false
      });
    }
    filterClear.current.clearAll = false;
    setCounter(counter + 1);
  };
  var filters = currentData === null || currentData === void 0 ? void 0 : currentData.map(function (item, index) {
    if (item.isDirty) {
      isAnyDirty = true;
    }
    if (!item.isEmpty) {
      areAllEmpty = false;
    }
    var selectProps = function selectProps(soft) {
      return item.type === "select" || item.type === "multiselect" ? {
        options: item.options,
        allowEmpty: true,
        value: item.value,
        onChange: function onChange(newVal) {
          return setValue(item.id, newVal, soft);
        }
      } : undefined;
    };
    var rangePickerProps = function rangePickerProps(soft) {
      return item.type === "range" ? {
        min: item.min,
        max: item.max,
        allowEmpty: item.allowEmpty,
        value: item.value,
        onChange: function onChange(newVal, isCommit) {
          setValue(item.id, newVal, !isCommit || soft);
        },
        fractionDigits: item.id === "capacity" ? 3 : 2
      } : undefined;
    };
    var clearButtonProps = function clearButtonProps(soft) {
      return {
        onClick: function onClick() {
          setValue(item.id, null, soft);
        }
      };
    };
    var commitButtonProps = function commitButtonProps() {
      return {
        onClick: function onClick() {
          commit();
        },
        disabled: !item.isDirty
      };
    };
    return _objectSpread(_objectSpread({}, item), {}, {
      selectProps: selectProps(false),
      rangePickerProps: rangePickerProps(false),
      clearButtonProps: clearButtonProps(false),
      commitButtonProps: commitButtonProps,
      soft: {
        selectProps: selectProps(true),
        rangePickerProps: rangePickerProps(true),
        clearButtonProps: clearButtonProps(true)
      }
    });
  });
  return {
    filters: filters,
    setValue: setValue,
    clearAll: function clearAll(isSoft) {
      data.forEach(function (item, index) {
        setValue(item.id, null, isSoft, false); // only last iteration should run onChange!
      });
      filterClear.current.clearAll = true;
      var committedValueToClear = filterClear.current.clear = filters.find(function (item, index) {
        return !item.isEmpty && data[index].value;
      });
      var notCommittedValuePreventClear = filters.find(function (item, index) {
        return !item.isEmpty && !data[index].value;
      });
      filterClear.current.clear = committedValueToClear && !notCommittedValuePreventClear;
    },
    commit: commit,
    isDirty: isAnyDirty,
    isEmpty: areAllEmpty,
    anyFilterChanged: anyFilterChanged
  };
}
var _default = useNormalizeAndMapFilters;
exports["default"] = _default;